import { BackgroundImage, Box, Container, Flex, Overlay } from '@mantine/core';

import { SectionTitle } from 'components';
import { NARROW_BACKGROUND_IMAGE } from 'constants/app';
import classes from './index.module.css';

interface INarrowSection {
  title: string;
  backgroundImg?: boolean;
  children: React.ReactNode
}

const NarrowSection = ({ backgroundImg = false, children, title }: INarrowSection) => {
  const content = (
    <Flex direction='column' align='center' gap={23} className={classes.content}>
      <SectionTitle title={title} />
      {children}
    </Flex>
  )

  return (
    <Container className={classes.container}>
      {backgroundImg ? (
        <BackgroundImage src={NARROW_BACKGROUND_IMAGE} className={`${classes.inner}  ${classes.image}`}>
          <Overlay className={classes.overlay} />
          {content}
        </BackgroundImage>
      ) : (
        <Box ta='center' className={`${classes.inner} ${classes.background}`}>
          {content}
        </Box>
      )}
    </Container>
  );
};

export default NarrowSection;
